import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

export function authHeaders(token) {
  return token ? { Authorization: `Bearer ${token}` } : {};
}

export function formatApiErrorDetail(detail) {
  if (detail == null) return 'Something went wrong. Please try again.';
  if (typeof detail === 'string') return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === 'string' ? e.msg : JSON.stringify(e))).filter(Boolean).join(' ');
  if (detail && typeof detail.msg === 'string') return detail.msg;
  return String(detail);
}

export async function fetchList(path, params) {
  const { data } = await api.get(path, { params });
  return data || [];
}

export async function fetchOne(path) {
  try {
    const { data } = await api.get(path);
    return data;
  } catch (e) {
    if (e.response && e.response.status === 404) return null;
    throw e;
  }
}

export function formatDate(d) {
  if (!d) return '';
  const date = new Date(`${d}T00:00:00` || d);
  if (Number.isNaN(date.getTime())) return d;
  return date.toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' });
}

export default API;